import { GallerySelectedMedia, GalleryState, GalleryThumbnails, IMediaType } from "@govlaunch/web";
import Box, { BoxProps } from "@govlaunch/web/src/box/Box";
import React from "react";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import isStockImage from "../utils/isStockImage";

interface IProductGalleryProps extends BoxProps {
  product: IProductFieldsFragment;
}

const isYoutube = (url: string) => url.includes("youtube.com") || url.includes("youtu.be");
const isVimeo = (url: string) => url.includes("vimeo.com");

export default function ProductGallery({ product }: IProductGalleryProps) {
  const screenshots = product.screenshots?.filter((image) => !isStockImage(image.url)) || [];
  const videos = product.enrichedProfile ? product.videos?.filter((url) => !isStockImage(url)) || [] : [];

  const videoMedias = videos.map((video, index) => {
    let type = IMediaType.Image;

    if (isYoutube(video)) {
      type = IMediaType.Youtube;
    }

    if (isVimeo(video)) {
      type = IMediaType.Vimeo;
    }

    return {
      url: video,
      type,
      alt: `${product.name} video ${index + 1}`,
    };
  });

  const screenshotMedias = screenshots.map((screenshot) => {
    return {
      url: screenshot.url,
      type: IMediaType.Image,
      alt: screenshot.alt,
    };
  });

  const medias = [...videoMedias, ...screenshotMedias];

  if (medias.length === 0) {
    medias.push({
      type: IMediaType.Image,
      url: `https://static.govlaunch.com/resources/gallery/0${Math.round(Math.random() * 5 + 1)}.png`,
      alt: `${product.name} gallery image`,
    });
  }

  return (
    <GalleryState medias={medias}>
      <GallerySelectedMedia />

      <Box height="1px" bg="gray.100" mt={3} />

      <GalleryThumbnails />
    </GalleryState>
  );
}
